module.exports = __webpack_public_path__ + "media/images/play-51fe4f7fe8196ac4f0f9d8e08ad8f7f8.svg";